import React, { RefObject } from "react";
import "./LoadingScreen.scss";

const LoadingScreen: React.FC<{
  progressRef: RefObject<HTMLDivElement>;
}> = (props): JSX.Element => {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const logo = require(`../../images/${process.env.REACT_APP_LOGO_IMAGE}`);

  return (
    <div className="LoadingScreen">
      <header className="header">
        <img src={logo.default} className="logo" alt="logo" />
        <p className="tagline">{process.env.REACT_APP_LOGO_SLOGAN}</p>
        <div className="progress-wrapper">
          <div className="ui tiny teal progress" ref={props.progressRef}>
            <div className="bar">
              <div className="progress"></div>
            </div>
          </div>
        </div>
      </header>
    </div>
  );
};

export default LoadingScreen;
